import { Http } from '@pirates/not-morty-biz';

export interface User {
  data: UserData;
}

export interface GetUser {
  body: UserData;
}

export interface UserData {
  id: string;
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  language: string;
  legalEntityId: number;
  phone: string;
}

interface BaseUserPayload {
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  language: string;
  phone: string;
}

export interface CreateUserPayload extends BaseUserPayload {
  password: string;
  legalEntityId: number;
}

export interface UpdateUserPayload extends BaseUserPayload {}

export interface UpdateUserPasswordPayload {
  password;
}

export class UserService {
  private baseUrl = '/api/b2b/admin-reggie/v1/public';

  public async create(payload: CreateUserPayload): Promise<User> {
    return Http.post<User>(`${this.baseUrl}/users`, payload);
  }

  public async get(): Promise<GetUser> {
    return Http.get<GetUser>(`${this.baseUrl}/users/me`);
  }

  public async update(payload: UpdateUserPayload): Promise<User> {
    return Http.put<User>(`${this.baseUrl}/users/me`, payload);
  }

  public async updatePassword(payload: UpdateUserPasswordPayload): Promise<Boolean> {
    return Http.put<Boolean>(`${this.baseUrl}/users/me/password`, payload);
  }
}

export const userService = new UserService();
